import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSignInRedirectTarget } from 'auth/hooks';
import { SignInSteps } from 'authOld/constants';
import { useAuthActions, useAuthModal } from 'authOld/hooks';
import { mapSignInForm } from 'authOld/mappers';
import { IAuthUserForm } from 'authOld/types';
import { login } from 'authOld/utils';
import { useNotification } from 'coreOld/hooks/useNotification';
import { goTo } from 'coreOld/utils';

import SignInFormView from './SignInFormView';

interface IProps {
  initialStep?: SignInSteps;
  email?: string;
}

const SignInForm = ({ initialStep, email }: IProps) => {
  const redirectTarget = useSignInRedirectTarget();
  const navigate = useNavigate();

  const [step, setStep] = useState(initialStep || SignInSteps.EMAIL);

  const { openedAuthModal, openAuthModal, closeAuthModal } = useAuthModal();

  const { clearNotification, showNotification } = useNotification();
  const { signIn } = useAuthActions();

  const onSubmit = () => async (data: IAuthUserForm) => {
    const { success, ssoEnabled, ssoRedirectUrl, redirect } = await signIn(
      mapSignInForm(data, step, redirectTarget)
    );

    if (!success) {
      return;
    }

    if (ssoEnabled && ssoRedirectUrl) {
      goTo(ssoRedirectUrl);

      return;
    }

    if (step === SignInSteps.EMAIL) {
      setStep(SignInSteps.PASSWORD);

      return;
    }

    await login(navigate, showNotification, redirect);
  };

  const goBack = () => {
    if (step === SignInSteps.PASSWORD) {
      clearNotification();
      setStep(SignInSteps.EMAIL);
    }
  };

  const onClose = () => {
    setStep(SignInSteps.EMAIL);
    closeAuthModal();
  };

  return (
    <SignInFormView
      openedAuthModal={openedAuthModal}
      openAuthModal={openAuthModal}
      onClose={onClose}
      step={step}
      onSubmit={onSubmit}
      goBack={goBack}
      email={email}
    />
  );
};

export default SignInForm;
